export const Constants = {
    INVITE_CODE_LENGTH: 6,
};

